import React, { useState, useEffect } from 'react';
import ProductCard from '../ProductCard';
import PreorderModal from '../PreorderModal/PreorderModal';
import { useCart } from '../../context/CartContext';
import './storeSection.css';
import ComingSoonModal from '../ComingSoonModal/ComingSoonModal';





const API_URL = '';





function StoreSection() {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
useEffect(() => {
    fetchFeaturedProducts();
  }, []); // Empty dependency array = run once on mount


  
  const { addToCart } = useCart();

  const fetchFeaturedProducts = async () => {
    try {
      let response = await fetch('/api/products/featured');
      
      if (!response.ok) {
        response = await fetch('/api/products');
      }
      
      const data = await response.json();
      const products = Array.isArray(data) ? data : data.products || [];
      const featured = products.filter(p => p.featured === true);
      
      setFeaturedProducts(featured);
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false); // IMPORTANT: Set loading to false when done

 


    }
  };

 
 


 
  const handlePreorderClick = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
  };

  const handleAddToCart = (product) => {
    console.log('Added to cart:', product);
    addToCart(product);
    alert(`${product.name} added to cart!`);
  };

  if (loading) {
    return <div className="loading">Loading featured products...</div>;
  }

  return (
    <section className="block-container" id="featured">
      <h2>Featured Products</h2>
      <div className="product-grid">
        {featuredProducts.map(product => (
          <ProductCard 
            key={product.id} 
            product={product}
            onPreorder={() => handlePreorderClick(product)}
            onAddToCart={() => handleAddToCart(product)}
          />
        ))}
      </div>
      <a href="/store" className="see-all-link">
        Browse Full Store →
      </a>

      {showModal && selectedProduct && (
        <PreorderModal
          product={selectedProduct}
          onClose={() => {
            setShowModal(false);
            setSelectedProduct(null);
          }}
        />
      )}
    </section>
  );
}

export default StoreSection;